import { z } from "../validation";

const isFunction = (value: unknown) => typeof value === "function";
// Componentes React podem ser funções ou objetos (memo/forwardRef).
const isComponent = (value: unknown) =>
  value === undefined ||
  typeof value === "function" ||
  (typeof value === "object" && value !== null);

const text = () => z.string().check(z.minLength(1));
const strings = () => z.optional(z.array(z.string()));

const NavItemSchema = z.object({
  label: text(),
  path: z.string().check(z.regex(/^(?!\/)/, "nav.path é relativo ao módulo (sem '/' inicial)")),
  icon: z.optional(z.custom(isComponent)),
  permission: z.optional(z.string()),
});

export const ModuleManifestSchema = z.object({
  id: z.string().check(z.regex(/^[a-z][a-z0-9-]*$/, "id deve ser kebab-case (é usado na URL)")),
  version: text(),
  meta: z.object({
    name: text(),
    description: z.optional(z.string()),
    icon: z.optional(z.custom(isComponent)),
    category: z.optional(z.enum(["core", "business", "support", "analytics"])),
    order: z.optional(z.number()),
    placement: z.optional(z.enum(["menu", "footer"])),
  }),
  requirements: z.optional(
    z.object({
      permissions: strings(),
      features: strings(),
      dependencies: strings(),
    }),
  ),
  nav: z.optional(z.array(NavItemSchema)),
  loader: z.custom<() => Promise<unknown>>(isFunction, "loader deve ser () => import(...)"),
});
